import logoBancolombia from './logo-bancolombia-transfer.png'
import logoBancolombiaCorresponsal from './logo-bancolombia-collect.png'
import logoNequi from './logo-nequi.png'
import logoPse from './logo-PSE.png'
import logoVisa from './logo-visa.png'
import logoMasterCard from './logo-mastercard.png'
import logoBellaPiel from './logo-BellaPiel.svg'


   export const imagenes: Record<string, string> = {
    NEQUI:logoNequi,
    PSE: logoPse,
    MASTERCARD: logoMasterCard, 
    VISA: logoVisa,
    BELLAPIEL: logoBellaPiel,
    BANCOLOMBIA_TRANSFER: logoBancolombia,
    BANCOLOMBIA_COLLECT: logoBancolombiaCorresponsal,
}